'use client';

import type { User } from '@/data/types/user';
import { useState } from 'react';

type AvatarUser = Pick<User, '_id' | 'displayName' | 'avatarUrl'>;

function avatarGradient(id: User['_id']) {
    const value = String(id);
    let hash = 2166136261;
    for (let index = 0; index < value.length; index++) {
        hash ^= value.charCodeAt(index);
        hash = Math.imul(hash, 16777619);
    }
    const hue = (hash >>> 0) % 360;
    return `linear-gradient(135deg, hsl(${hue} 62% 46%), hsl(${(hue + 24) % 360} 70% 57%))`;
}

export function UserAvatar({ user, size = 40, className = '' }: { user: AvatarUser; size?: number; className?: string; }) {
    const [imageFailed, setImageFailed] = useState(false);
    const letter = (user.displayName ?? '?').trim().charAt(0).toUpperCase() || '?';

    return (
        <span className={`relative inline-grid shrink-0 place-items-center overflow-hidden rounded-full text-sm font-black text-white shadow-card ${className}`} style={{ width: size, height: size, backgroundImage: avatarGradient(user._id) }} aria-label={user.displayName} role="img">
            <span aria-hidden>{letter}</span>
            {user.avatarUrl && !imageFailed && <img src={user.avatarUrl} alt="" className="absolute inset-0 size-full object-cover" onError={() => setImageFailed(true)} />}
        </span>
    );
}